/**
 * A snapshot species' typing as it was in a given generation, using the
 * `pastTypes` history baked into the snapshot (Gen 1 Magnemite is pure
 * Electric, pre-Gen 6 Clefairy is Normal, …). Falls back to current types.
 */
export function typesForGen(species, gen = 9) {
  const past = species && species.pastTypes;
  if (past && past.length) {
    const era = [...past].sort((a, b) => a.gen - b.gen).find((p) => p.gen >= gen);
    if (era) return era.types;
  }
  return (species && species.types) || [];
}
